export const stagingConfig = {
  SERVER_URL: 'https://sgerp-stage.d.gcdev.swatrider.com/api/v2',
}
